import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';
import { selectCurrentPromptType } from 'services/store/ai/selectors';
import { PromptType } from 'services/store/ai/types';
import { AdvancedFormulaPanel } from './components';
import TextToMusicFormulaPanel from './components/TextToMusicFormulaPanel';
import {
  StyledFormulaContainer,
  StyledSidebarContainer,
  StyledWrapper,
} from './styled';
import PromptTypeToggle from './components/PromptTypeToggle';
import { UserLoop } from './components/UserLoop';

const Sidebar = () => {
  const theme = useTheme();
  const promptType = useSelector(selectCurrentPromptType);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledSidebarContainer>
      {!isMobile && (
        <StyledWrapper>
          <PromptTypeToggle />
          <UserLoop />
        </StyledWrapper>
      )}

      <StyledFormulaContainer>
        {promptType === PromptType.TextToMusic ? (
          <TextToMusicFormulaPanel />
        ) : (
          <AdvancedFormulaPanel />
        )}
      </StyledFormulaContainer>
    </StyledSidebarContainer>
  );
};
export default memo(Sidebar);
